import intl from 'react-intl-universal'

/*@@
  @Name: localize.jsx
  @Description: Use translate to localize and intl.get for internationalization
  @Usage
     {translate('user_name')}   or  {intl.get('DATE_short',  {value: date_created)}

     {number_intl(100000)}       We can add additional formating as we go
 */


const translate = (key, params=null) => {
    let l10n_text = intl.get(key, params)
    if (l10n_text.trim().length == 0) {
        const locale = document.cookie.split('lang=')[1]
        l10n_text = key
        console.error(`Missing translation for '${key}' for locale '${locale}'.`)
    }
    return l10n_text
}

const translateHTML = (key, params=null) => {
    let l10n_text = intl.getHTML(key, params)
    if (typeof l10n_text === 'undefined') {
        const locale = document.cookie.split('lang=')[1]
        l10n_text = key
        console.error(`Missing translation for '${key}' for locale '${locale}'.`)
    }
    return l10n_text
}

const number_intl = (n)=>{
    //null is not the same is 0
    //TODO we may need the same directly from react-intl-universal OR make sure we always use this method
    if (n == null || (n.trim && n.trim() == '')) {
        return ''
    }
    return intl.get('NUMBER_FORMAT', { n: n })
}

const number_options_intl = (n, digits)=>{
    //TODO: add react number intl framework
    return Number.parseFloat(n).toFixed(digits)
}

const two_digits_date = (date) => {
    return new Intl.DateTimeFormat(intl.get('locale'), {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}

export {translate, translateHTML, number_intl, number_options_intl, two_digits_date, intl}